/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import Content from 'app/components/common/Content.jsx';
import { FormattedDate } from 'react-intl';
import { FormattedNumber } from 'react-intl';
import Loading from 'app/components/common/Loading.jsx';
import EmptyState from 'app/components/common/EmptyState.jsx';
import * as _ from 'underscore';
import ComponentWithContext from 'app/components/Routers/ComponentWithContext.jsx';
import PaymentHistoryShad from '@/shadcn/components/account/PaymentHistory.tsx';

class PaymentHistory extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            invoices: [],
            initialLoad: true,
            loadingInvoice: 0
        };

        this.openInvoice = this.openInvoice.bind(this);

    }

    componentDidMount() {

        if (this.props.user.detail.isAgent === false) {
            this.props.getInvoices();
        }

    }

    componentDidUpdate(prevProps, prevState) {
        let constants = this.props.app.config.constants;

        if (prevProps.app.loading.SUB_FETCH_INVOICES === true && this.props.app.loading.SUB_FETCH_INVOICES === false) {
            if (this.props.plans.invoices.length === 0 && this.props.isFreeUser()) {
                this.props.router.navigate('/account/subscription/new');
            }
        }

        if (_.isEmpty(prevProps.plans.invoice) && !_.isEmpty(this.props.plans.invoice)) {
            let pdf = document.createElement('a');
            pdf.target = "_blank";
            pdf.download = "invoice.pdf";
            pdf.href = "data:application/pdf;base64," + invoice;
            pdf.click();
        }

    }

    openInvoice(e) {

        let id = e.currentTarget.dataset.invoice;

        window.open('/invoice.php?id=' + id);

    }

    render() {
        let main = null;

        if (this.props.user.detail.isAgent) {
            main = <EmptyState message={"Sorry, only the account owner can access this page."}/>;
        } else if (!this.props.plans.invoices.length && this.props.app.loading.SUB_FETCH_INVOICES) {
            main = (
                <Loading/>
            );
        } else {
            main = (
                <div className="tw-root">
                    <PaymentHistoryShad
                        invoices={this.props.plans.invoices}
                        openInvoice={this.openInvoice}/>
                </div>
            );
        }

        return (
            <Content header={null} main={main} />
        );
    }

};

PaymentHistory.displayName = "PaymentHistory";

export default ComponentWithContext(PaymentHistory);
